import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import { navLinks, companyInfo } from '../../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_71122495-5c3a-44f9-81bc-14be3cbb18e4/artifacts/cv5kk375_sportiva-infotech%20logo.png";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-white/95 backdrop-blur-md shadow-sm' :
      'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group">
            <img
              src={LOGO_URL}
              alt="Sportiva Infotech"
              className="h-35 w-40 object-contain !mt-[0px] !mb-[0px]" />

          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) =>
            <button
              key={link.label}
              onClick={() => scrollToSection(link.href)}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all hover:bg-[#1e3a5f]/5 ${
              isScrolled ? 'text-[#1e3a5f]' : 'text-[#1e3a5f]'}`
              }>

                {link.label}
              </button>
            )}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button
              onClick={() => scrollToSection('#contact')}
              className="bg-[#f26522] hover:bg-[#d95a1b] text-white px-6 py-2 rounded-lg font-medium transition-all hover:shadow-lg hover:-translate-y-0.5">

              Get in Touch
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

            {isMobileMenuOpen ?
            <X className="w-6 h-6 text-[#1e3a5f]" /> :

            <Menu className="w-6 h-6 text-[#1e3a5f]" />
            }
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg transition-all duration-300 ${
        isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`
        }>

        <nav className="flex flex-col p-4 gap-1">
          {navLinks.map((link) =>
          <button
            key={link.label}
            onClick={() => scrollToSection(link.href)}
            className="px-4 py-3 text-left text-[#1e3a5f] font-medium rounded-lg hover:bg-gray-50 transition-colors">

              {link.label}
            </button>
          )}
          <Button
            onClick={() => scrollToSection('#contact')}
            className="mt-4 bg-[#f26522] hover:bg-[#d95a1b] text-white">

            Get in Touch
          </Button>
        </nav>
      </div>
    </header>);

};